import './NavBar.css'
import NavLinks from '../NavBar/NavLinks'

const Navigation =()=>{
    return(
        <nav className='navNavigation'>
            <NavLinks/> 
        </nav>
    )
}

export default Navigation